<template>
  <el-dialog
    title="分类信息"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="80px"
      size="small"
    >
      <el-form-item
        prop="businessid"
        label="分类编号"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.businessid"></el-input>
      </el-form-item>
      <el-form-item
        prop="businessname"
        label="分类名称"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.businessname"></el-input>
      </el-form-item>
      <el-form-item
        prop="sort_id"
        label="排序"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.sort_id"></el-input>
      </el-form-item>


      <el-form-item label="分类图片" prop="imgpath"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.imgpath" style="display:none"></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=1
                :auto-upload="true"
                :file-list="fileList"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemove"
                :on-success="handlePictureCardPreview">
          <i class="el-icon-plus"></i>
        </el-upload>
        建议尺寸1000*600像素，大小1M以内，支持jpg、png、jpeg格式
      </el-form-item>

      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
    import * as oneclassService from "@/api/sys/oneclass";
    import util from '@/libs/util.js'
export default {
  name: "oneclassEditForm",
  props: {
      oneclass: Object,
    value: Boolean
  },
  data() {
    return {
        imgUrl: process.env.VUE_APP_API+"/moblieapp/currencyUpload",
        formEdit: true,
      loading: false,
      dialogVisible: false,
        fileList: [],
      form: {
          businessid: "",
          businessname: "",
          imgpath: "",
          sort_id: ""
      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();
      if (this.oneclass.id) {
       // userService.getUser(this.user.id).then(data => {
          let form = {};
          form.businessid = this.oneclass.businessid;
          form.businessname = this.oneclass.businessname;
          form.sort_id = this.oneclass.sort_id;
          if(this.oneclass.imgpath!=null && this.oneclass.imgpath!="") {
              form.imgpath = this.oneclass.imgpath;
              this.fileList = [{url: 'https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/' + this.oneclass.imgpath}]
          }
          this.form = form;
       // });
          this.formEdit = true;
      } else {
          this.formEdit = true;
          this.fileList=[];
        this.form = {};
      }
    },
      // 上传文件之前的钩子
      handleBeforeUpload(file){
          let isJPG =true;
          // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
          console.log('before');
          if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
              isJPG=false;
              this.$notify.warning({
                  title: '警告',
                  message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
              })

          }
          let size = file.size / 1024 / 1024 / 2
          if(size > 2) {
              this.$notify.warning({
                  title: '警告',
                  message: '图片大小必须小于2M'
              })
              isJPG=false;
          }

          return isJPG // 返回false不会自动上传
      },
      // 文件超出个数限制时的钩子
      handleExceed(files, fileList) {

      },
      // 文件列表移除文件时的钩子
      handleRemove(file, fileList) {
          this.form.imgpath ="";
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview(file) {
          console.log("url==="+file.url);
          this.form.imgpath = file.url;
          this.dialogVisible = true;
      },
    saveUser() {
      this.$refs["form"].validate(valid => {
        if (valid) {
            var formData = new FormData() // 声明一个FormData对象
           // formData.append('file', this.files, this.fileName);//filename是键，file是值，就是要传的文件，test.zip是要传的文件名

            formData.append('businessid',this.form.businessid)
            formData.append('businessname',this.form.businessname)
            formData.append('sort_id',this.form.sort_id)
            formData.append('imgpath',this.form.imgpath)
            formData.append('xt_id',util.cookies.get('xt_id'))
            formData.append('agentid',util.cookies.get('agentid'))
            if(this.oneclass.id!=null && this.oneclass.id!="") {
                formData.append('id', this.oneclass.id)
            }
                        this.loading = true;
            oneclassService
                            .saveOneclassAgent(formData)
                            .then(data => {
                                this.loading = false;
                                this.dialogVisible = false;
                                this.$emit("submit");
                            });


        } else {
          return false;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

